<div  [ngClass]="{'reviewStatusWorkpaper':colDefFor=='dtDashboardWorkpaperTab'}"  [ngStyle]="parentStyle">
    <ng-container  *ngTemplateOutlet="template; context: templateContext"></ng-container>
</div>